"use strict";

var _regeneratorRuntime = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Safe = void 0;

var ethers_1 = require("ethers");

var signatures_1 = require("./signatures");

var methods_1 = require("../communication/methods");

var constants_1 = require("../eth/constants");

var Safe = /*#__PURE__*/function () {
  function Safe(communicator) {
    _classCallCheck(this, Safe);

    this.communicator = communicator;
  }

  _createClass(Safe, [{
    key: "getChainInfo",
    value: function () {
      var _getChainInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.communicator.send(methods_1.Methods.getChainInfo, undefined);

              case 2:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getChainInfo() {
        return _getChainInfo.apply(this, arguments);
      }

      return getChainInfo;
    }()
  }, {
    key: "getInfo",
    value: function () {
      var _getInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.communicator.send(methods_1.Methods.getSafeInfo, undefined);

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getInfo() {
        return _getInfo.apply(this, arguments);
      }

      return getInfo;
    }() // There is a possibility that this method will change because we may add pagination to the endpoint

  }, {
    key: "experimental_getBalances",
    value: function () {
      var _experimental_getBalances = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _ref,
            _ref$currency,
            currency,
            response,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ref = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref$currency = _ref.currency, currency = _ref$currency === void 0 ? 'usd' : _ref$currency;
                _context3.next = 3;
                return this.communicator.send(methods_1.Methods.getSafeBalances, {
                  currency: currency
                });

              case 3:
                response = _context3.sent;
                return _context3.abrupt("return", response.data);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function experimental_getBalances() {
        return _experimental_getBalances.apply(this, arguments);
      }

      return experimental_getBalances;
    }()
  }, {
    key: "check1271Signature",
    value: function () {
      var _check1271Signature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(messageHash) {
        var signature,
            safeInfo,
            encodedIsValidSignatureCall,
            payload,
            response,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                signature = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : '0x';
                _context4.next = 3;
                return this.getInfo();

              case 3:
                safeInfo = _context4.sent;
                encodedIsValidSignatureCall = signatures_1.EIP_1271_INTERFACE.encodeFunctionData('isValidSignature', [messageHash, signature]);
                payload = {
                  call: constants_1.RPC_CALLS.eth_call,
                  params: [{
                    to: safeInfo.safeAddress,
                    data: encodedIsValidSignatureCall
                  }, 'latest']
                };
                _context4.prev = 6;
                _context4.next = 9;
                return this.communicator.send(methods_1.Methods.rpcCall, payload);

              case 9:
                response = _context4.sent;
                return _context4.abrupt("return", response.data.slice(0, 10).toLowerCase() === signatures_1.MAGIC_VALUE);

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](6);
                return _context4.abrupt("return", false);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[6, 13]]);
      }));

      function check1271Signature(_x) {
        return _check1271Signature.apply(this, arguments);
      }

      return check1271Signature;
    }()
  }, {
    key: "check1271SignatureBytes",
    value: function () {
      var _check1271SignatureBytes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(messageHash) {
        var signature,
            safeInfo,
            msgBytes,
            encodedIsValidSignatureCall,
            payload,
            response,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                signature = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : '0x';
                _context5.next = 3;
                return this.getInfo();

              case 3:
                safeInfo = _context5.sent;
                msgBytes = ethers_1.ethers.utils.arrayify(messageHash);
                encodedIsValidSignatureCall = signatures_1.EIP_1271_BYTES_INTERFACE.encodeFunctionData('isValidSignature', [msgBytes, signature]);
                payload = {
                  call: constants_1.RPC_CALLS.eth_call,
                  params: [{
                    to: safeInfo.safeAddress,
                    data: encodedIsValidSignatureCall
                  }, 'latest']
                };
                _context5.prev = 7;
                _context5.next = 10;
                return this.communicator.send(methods_1.Methods.rpcCall, payload);

              case 10:
                response = _context5.sent;
                return _context5.abrupt("return", response.data.slice(0, 10).toLowerCase() === signatures_1.MAGIC_VALUE_BYTES);

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](7);
                return _context5.abrupt("return", false);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[7, 14]]);
      }));

      function check1271SignatureBytes(_x2) {
        return _check1271SignatureBytes.apply(this, arguments);
      }

      return check1271SignatureBytes;
    }()
  }, {
    key: "calculateMessageHash",
    value: function calculateMessageHash(message) {
      return ethers_1.ethers.utils.hashMessage(message);
    }
  }, {
    key: "isMessageSigned",
    value: function () {
      var _isMessageSigned = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(message) {
        var signature,
            messageHash,
            messageHashSigned,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                signature = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : '0x';
                messageHash = this.calculateMessageHash(message);
                _context6.next = 4;
                return this.isMessageHashSigned(messageHash, signature);

              case 4:
                messageHashSigned = _context6.sent;
                return _context6.abrupt("return", messageHashSigned);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function isMessageSigned(_x3) {
        return _isMessageSigned.apply(this, arguments);
      }

      return isMessageSigned;
    }()
  }, {
    key: "isMessageHashSigned",
    value: function () {
      var _isMessageHashSigned = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(messageHash) {
        var signature,
            checks,
            _i,
            _checks,
            check,
            isValid,
            _args7 = arguments;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                signature = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : '0x';
                checks = [this.check1271Signature.bind(this), this.check1271SignatureBytes.bind(this)];
                _i = 0, _checks = checks;

              case 3:
                if (!(_i < _checks.length)) {
                  _context7.next = 13;
                  break;
                }

                check = _checks[_i];
                _context7.next = 7;
                return check(messageHash, signature);

              case 7:
                isValid = _context7.sent;

                if (!isValid) {
                  _context7.next = 10;
                  break;
                }

                return _context7.abrupt("return", true);

              case 10:
                _i++;
                _context7.next = 3;
                break;

              case 13:
                return _context7.abrupt("return", false);

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function isMessageHashSigned(_x4) {
        return _isMessageHashSigned.apply(this, arguments);
      }

      return isMessageHashSigned;
    }()
  }]);

  return Safe;
}();

exports.Safe = Safe;